import { useTranslation } from 'react-i18next'

import DownloadIcon from '@/assets/icons/download.svg?react'

import styles from './ExportButton.module.scss'
import Button from '../Button/Button'
import Dropdown, { DropdownMenuItem } from '../Dropdown/Dropdown'

export type ExportButtonProps = {
  isDownloadLoading?: boolean
  onPdfExport?: () => void
  onXlsExport?: () => void
  onPrint?: () => void
}

const ExportButton = (props: ExportButtonProps) => {
  const { t } = useTranslation('common')

  const actions = [
    {
      text: t('text.pdf'),
      onClick: props.onPdfExport
    },
    {
      text: t('text.xls'),
      onClick: props.onXlsExport
    },
    {
      text: t('text.print'),
      onClick: props.onPrint
    }
  ].filter(action => action.onClick)

  return (
    <Dropdown
      trigger={
        <Button loading={props.isDownloadLoading} icon={<DownloadIcon />}>
          {t('button.export')}
        </Button>
      }
    >
      {actions.map((action, index) => (
        <DropdownMenuItem
          onClick={action.onClick}
          key={index}
          className={styles.item}
        >
          {action.text}
        </DropdownMenuItem>
      ))}
    </Dropdown>
  )
}

export default ExportButton
